import { render, staticRenderFns } from "./CustomersById.vue?vue&type=template&id=ceb16fc6&scoped=true"
import script from "./CustomersById.vue?vue&type=script&lang=js"
export * from "./CustomersById.vue?vue&type=script&lang=js"
import style0 from "./CustomersById.vue?vue&type=style&index=0&id=ceb16fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb16fc6",
  null
  
)

export default component.exports